// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";

function PositionSquare(Props) {
  var classNameOpt = Props.className;
  var sOpt = Props.size;
  var pl = Props.pl;
  var queueId = Props.queueId;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var s = sOpt !== undefined ? sOpt : 32;
  var pl$1 = queueId !== 1150 && queueId !== 1160 ? pl : (pl + 1 | 0) / 2 | 0;
  var tmp;
  switch (pl$1) {
    case 1 :
        tmp = Colors.legendaryDesaturated2;
        break;
    case 2 :
        tmp = Colors.epicDesaturated2;
        break;
    case 3 :
        tmp = Colors.rareDesaturated2;
        break;
    case 4 :
        tmp = Colors.uncommonDesaturated2;
        break;
    default:
      tmp = Colors.common;
  }
  var c = CssJs.hex(tmp);
  var cBg;
  switch (pl$1) {
    case 1 :
        cBg = Colors.legendaryDesaturatedAlpha2(0.1);
        break;
    case 2 :
        cBg = Colors.epicDesaturatedAlpha2(0.1);
        break;
    case 3 :
        cBg = Colors.rareDesaturatedAlpha2(0.1);
        break;
    case 4 :
        cBg = Colors.uncommonDesaturatedAlpha2(0.1);
        break;
    default:
      cBg = Colors.commonAlpha(0.1);
  }
  var fs = s >= 32 ? 25 : (
      s >= 28 ? 23 : (
          s >= 26 ? 21 : 17
        )
    );
  return React.createElement("div", {
              className: CssJs.merge([
                    className,
                    "font-montserrat font-semibold flex items-center justify-center",
                    CssJs.style([
                          CssJs.fontSize(CssJs.px(fs)),
                          CssJs.width(CssJs.px(s)),
                          CssJs.height(CssJs.px(s)),
                          CssJs.borderRadius(CssJs.px(6)),
                          CssJs.color(c),
                          CssJs.border(CssJs.px(2), CssJs.solid, c),
                          CssJs.background(cBg)
                        ])
                  ])
            }, String(pl$1));
}

var make = PositionSquare;

export {
  make ,
  
}
/* CssJs Not a pure module */
